module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/lista-inscritos",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Lista Inscritos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tempo",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Tempo")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/resultados",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Resultados")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/doc/regulamento.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Regulamento")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7c00c68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pub/Nav.vue
// module id = 269
// module chunks = 1